<script>
    import {Bar} from 'vue-chartjs'
    import {CustomTooltips} from '@coreui/coreui-plugin-chartjs-custom-tooltips'
    import {hexToRgba} from '@coreui/coreui/dist/js/coreui-utilities'

    export default {
        components: {
            hexToRgba,
            CustomTooltips
        },
        extends: Bar,
        mounted() {
            this.renderChart(
                {
                    labels: ['Personas'],
                    datasets: [
                        {
                            label: 'De 18 a 30',
                            backgroundColor: hexToRgba('#00ff41', 70),
                            fill: true,
                            data: [140]
                        },
                        {
                            label: 'De 31 a 50',
                            backgroundColor: hexToRgba('#ffec3c', 70),
                            fill: true,
                            data: [230]
                        },
                        {
                            label: 'Más de 50',
                            backgroundColor: hexToRgba('#ff0326', 70),
                            fill: true,
                            data: [138]
                        }
                    ]
                },
                {
                    responsive: true,
                    scales: {
                        yAxes: [{
                            stacked: false,
                            ticks: {
                                precision: 0,
                                beginAtZero: true,
                                suggestedMax: 50
                            }
                        }]
                    },
                    maintainAspectRatio: true,
                    tooltips: {
                        enabled: false,
                        custom: CustomTooltips,
                        intersect: false,
                        mode: 'index',
                        position: 'nearest',
                        callbacks: {
                            labelColor: function (tooltipItem, chart) {
                                return {backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor}
                            }
                        }
                    }
                }
            )
        }
    }
</script>
